import React from 'react'
import { Col, Row, Card } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import img from '../img/FA.jpg';
import img1 from '../img/Account 3.jpg';
import img2 from '../img/Accounting-Banner.jpg';
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function FinancialAccountingSoftware() {
  return (
    <>
      <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
      <div className="container my-4 fs-6">
        <Row>
          <Col xs={12} sm={9}>
            <h1 className='mt-4 pt-4 text-danger'>Financial Accounting</h1>
            {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
            <p className='text-justify'>CATUS is designed based on international accounting principles. Logistics software with financial accounting it provides facility of multiple currency transactions, budgeting, credit control, partner receivables. View and analyze detailed shipment profitability. Our CATUS Logistics Software is tightly bound with operational and financial accounting modules. It is also very useful for the management level to understand the profitability of every job report on a single click.</p>
            <p className='text-justify'>CATUS helps you to imagine a successful business model that determines how well your business grows. Logistics software with financial accounting it brings your business to new heights of integration. It allows you to be access your business from almost anywhere via computer.</p>
            <p className='text-justify'>You will be probably shocked to see how many hours you was wasting doing work in your existing environment. We pride on our support services which are second to none and the reason that many of our customers either choose us in the first place, or switched to us subsequently. Our Advanced software ensure you, end-to-end functionality. You will be probably shocked to see how many hours you was wasting doing work in your existing environment.</p>
            <p className='text-justify'>Catus Technologies' Logistics Software stands as a transformative tool in the logistics and financial management landscape. Its blend of international accounting compliance, advanced features, and exceptional support positions it as an indispensable asset for businesses aiming to achieve sustained growth and operational excellence.</p>
            <h5>GST INTEGRATED LOGISTICS SOFTWARE</h5>
            {/* <p>Automated billing with GST calculations according to inter or intra state rate calculation.</p> */}
            <div className="flex justify-center">
              <Image
                className="fade-in animated-card mt-2"
                src={img2}
                alt=""
                style={{
                  width: "100%",
                  maxWidth: "960px",
                  height: "200px",
                  // objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>

          </Col>
          <Col xs={12} sm={3}>
            <Sidebar />
          </Col>
          <Col>

            <Card className='my-5 animated-card' border="primary">
              <Card.Body> <strong>Key Features of our Financial Accounting Software</strong></Card.Body>
              <hr />
              <Card.Body>
                <Row>
                  <Col md={4}><ul>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Raise Quotation and Invoice</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Raise Overseas Invoice</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Raise Miscellaneous Invoice/Credit Note (Not Related to a Job)</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Register Overseas Agent Invoice/Credit Note</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Receipt/Payment/Contra /Journal Voucher</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Accounts Ledger</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>TDS Voucher and Reports</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Credit control module with credit related auto-alerts</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Budgeting and forecast reports</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Expense Memo (General/Operational)</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Bank Reconciliation</li>
                    <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Sub Ledger</li>

                  </ul></Col>
                  <Col md={4} className="d-flex justify-content-center">
                    <img
                      src={img1}
                      alt="Features Illustration"
                      style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                    /></Col>
                  <Col md={4}>
                    <ul>

                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Sub Ledger Schedule (As on Date/For a Period)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Books of Accounts</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Statement of Account (Summary/Detailed)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Ageing Analysis</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Month wise Sales/Purchase Report (Summary/Detailed)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Cash/Bank Balances</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>GST Reports (Input/Output)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Job Costing (On a Single Click)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Cargo Sales Report (CSR)</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Trial Balance</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Profit and Loss</li>
                      <li className='fs-6' style={{ textIndent: "-1.5rem" }}>Balance Sheet</li>
                      And Many More…
                    </ul>
                  </Col>
                </Row>

              </Card.Body>
            </Card>
            <ul>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>International Accounting Compliance</strong>: Adheres to IFRS and GAAP for reliable financial management.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Multiple Currency Transactions</strong>: Supports real-time conversion and reconciliation across various currencies.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Budgeting Tools</strong>: Enables precise financial planning and resource allocation.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Credit Control</strong>: Monitors credit limits and manages overdue payments to mitigate risks.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Partner Receivables Management</strong>: Streamlines invoicing and payment collection from partners.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Shipment Profitability Analysis</strong>: Provides detailed insights into per-shipment financial performance.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>One-Click Job Reports</strong>: Generates detailed profitability reports for management with a single click.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Integrated Modules</strong>: Tightly binds operational and financial accounting for cohesive management.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>Remote Access</strong>: Allows business management from anywhere via computer.</li>
              <li class="fs-6" style={{ textIndent: "-1.5rem" }}><strong>End-to-End Functionality</strong>: Covers all logistics and financial processes from cargo handling to profit analysis.</li>
            </ul>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default FinancialAccountingSoftware